// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconGridTwoByTwo, iconGridTwoByTwoTag } from '@ni/nimble-components/dist/esm/icons/grid-two-by-two';
import { wrap } from '../../utilities/react-wrapper';

export type { IconGridTwoByTwo };
export { iconGridTwoByTwoTag };
export const NimbleIconGridTwoByTwo = wrap(IconGridTwoByTwo);